import TranslatedActionSplitDropdown from './ActionSplitDropdown.component';

export default TranslatedActionSplitDropdown;
